export default __webpack_public_path__ + "static/media/TnB0413.c406a4d7.jpg";